import React, {
  createContext,
  ReactNode,
  useContext,
  useRef,
  useState,
} from "react";
import BranchFollowGroupsProvider from "./BranchFollowGroupsProvider";
import { FollowGroupsList } from "../../../model/branch/BranchFollowGroupsListModel";
import { AlertMesage } from "../../../widget/common/ui/Alerts";
import Loader from "../../../widget/common/ui/Loader";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

type BranchFollowGroupsContextType = {
  groupList: Array<FollowGroupsList> | null;
  selectedGroupIds: Array<string>;
  getGroupsListAPI: () => void;
  onClikcReset: () => void;
  onClickSubmit: () => void;
  onClickItem: (item: FollowGroupsList) => void;

  showSearch: boolean;
  searchValue: string;
  handleOnChange: (name: string, value: string) => void;
  clearSearch: () => void;
  updateShowSearch: () => void;
};

const BranchFollowGroupsContext = createContext<
  BranchFollowGroupsContextType | undefined
>(undefined);

export const BranchFollowGroupsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const searchValueRef = useRef<string>("");
 const groupListResultRef = useRef<Array<FollowGroupsList> | null>(null);

  const [selectedGroupIds, setSelectedGroupIds] = useState<Array<string>>([]);
  const [groupList, setGroupList] = useState<Array<FollowGroupsList> | null>(
    null
  );
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");

 

  const getGroupsListAPI = async () => {
    const branchFollowGroupsListModel =
      await BranchFollowGroupsProvider.getGroupsListAPI();
    if (branchFollowGroupsListModel != null) {
      groupListResultRef.current =
        branchFollowGroupsListModel?.result?.follow_groups_list!;

      setGroupList(groupListResultRef.current);
      resetGroupsids();
    }
  };

  const resetGroupsids = (): Array<string> => {
    let gIds: Array<string> = [];
    groupListResultRef.current!.forEach((item) => {
      if (item.status === "1") {
        gIds.push(item.group_id!);
      }
    });
    setSelectedGroupIds(gIds);
    return gIds;
  };

  const handleOnChange = (fieldName: string, fieldValue: string) => {
    fieldName = fieldName.toLowerCase();
    if (fieldName === `search-follow-groups`) {
      setSearchValue(fieldValue);
      searchValueRef.current = fieldValue;

      const filtered: Array<FollowGroupsList> | undefined =
        groupListResultRef.current?.filter((group) =>
          Object.values(group)
            .join(" ")
            .toLowerCase()
            .includes(searchValueRef.current.toLowerCase())
        );

      setGroupList(filtered!);
    }
  };

  const clearSearch = () => {
    if (UtilityHelper.isEmpty(searchValueRef.current)) {
      updateShowSearch();
    }
    setGroupList(groupListResultRef.current);
    setSearchValue("");
    searchValueRef.current = "";
  };

  const updateShowSearch = () => {
    setShowSearch(!showSearch);
  };

  const onClikcReset = () => resetGroupsids();

  const onClickSubmit = async () => {
    if (
      UtilityHelper.areArraysEqualUnordered(resetGroupsids(), selectedGroupIds)
    ) {
      showAlert();
    } else {
      Loader.modal();
      const statusResponse: boolean =
        await BranchFollowGroupsProvider.submitSelection(selectedGroupIds);
      Loader.modal(false);
      if (statusResponse) {
        //setSelectedGroupIds([...selectedGroupIds]);
        showAlert();
      }
    }
  };

  const showAlert = () => {
    AlertMesage({
      title: "follow_group_successfully_updated",
      onClick: () => {
        BranchFollowGroupsProvider.navigate(-1);
      },
    });
  };

  const onClickItem = (item: FollowGroupsList) => {
    const gId: string = item.group_id!;

    if (!selectedGroupIds.includes(gId)) {
      setSelectedGroupIds([...selectedGroupIds, gId]);
    } else {
      setSelectedGroupIds(
        selectedGroupIds.filter((groupId) => groupId !== gId)
      );
    }
  };

  return (
    <BranchFollowGroupsContext.Provider
      value={{
        groupList,
        selectedGroupIds,
        getGroupsListAPI,
        onClikcReset,
        onClickSubmit,
        onClickItem,

        showSearch,
        searchValue,
        handleOnChange,
        clearSearch,
        updateShowSearch,
      }}
    >
      {children}
    </BranchFollowGroupsContext.Provider>
  );
};

// IMPORT / USE CONTEXT ///////////////////////////////////////////////////////////////////
export const BranchFollowGroupsContextImport = () => {
  const context = useContext(BranchFollowGroupsContext);
  if (!context) {
    throw new Error(
      "BranchFollowGroupsContextImport must be used within a BranchFollowGroupsContextProvider"
    );
  }
  return context;
};
